import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CPQScreen, CPQScreenOption } from '../../../models/CPQUI';


@Component({
  selector: 'app-cpqscreen',
  templateUrl: './cpqscreen.component.html',
  styleUrls: ['./cpqscreen.component.css']
})
export class CPQScreenComponent implements OnInit {
  @Output() ChangeEmitter: EventEmitter<CPQScreenOption> = new EventEmitter();
  @Output() InvalidEmitter: EventEmitter<any> = new EventEmitter();
  @Input() CurrentScreen: CPQScreen;
  constructor() { }

  ngOnInit(): void {
  }

  OnScreenOptionChange(event: CPQScreenOption) {
    this.ChangeEmitter.emit(event);
  }

  OnInvalidEmitter(event: string) {
    this.InvalidEmitter.emit(event);
  }
}
